import LegalLayout from "@/components/LegalLayout";

const SECTIONS = [
  {
    heading: "What we collect",
    body: "When you register or book a service we collect your name, email address, phone number and the details of the job you describe. When you browse the site we collect standard technical logs (browser type, pages visited) used only to keep the platform reliable.",
  },
  {
    heading: "How we use it",
    body: "Your details exist for one reason: to get a technician to your door. We use them to confirm bookings, dispatch crews, honour warranties and contact you about active jobs. We do not sell, rent or trade your personal data to anyone.",
  },
  {
    heading: "Cookies & sessions",
    body: "We use secure, httpOnly cookies to keep you signed in between visits. These cookies carry no personal information beyond an anonymous session token and expire automatically. No advertising or cross-site tracking cookies are used.",
  },
  {
    heading: "Storage & security",
    body: "Passwords are stored only as industry-standard bcrypt hashes — never in plain text. Job records and contact requests are held in access-controlled systems and retained only as long as needed for warranty and legal obligations.",
  },
  {
    heading: "Your rights",
    body: "You may ask us at any time to see, correct or delete the personal data we hold about you. Write to hello@nucservice.com and we will respond within 7 working days.",
  },
];

export default function Privacy() {
  return (
    <LegalLayout
      kicker="Legal — 01"
      title="Privacy Policy"
      updated="June 2026"
      sections={SECTIONS}
      testId="privacy-page"
    />
  );
}
